import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <div className="services">
      <section className="services-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive learning solutions for your educational journey</p>
        </div>
      </section>

      <section className="services-grid">
        <div className="container">
          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-laptop-code"></i>
            </div>
            <h3>Online Courses</h3>
            <p>Access our extensive library of courses taught by industry experts</p>
            <button className="learn-more">Learn More</button>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-chalkboard-teacher"></i>
            </div>
            <h3>Live Mentoring</h3>
            <p>One-on-one guidance from experienced mentors in your field</p>
            <button className="learn-more">Learn More</button>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-users"></i>
            </div>
            <h3>Group Projects</h3>
            <p>Collaborate with peers on real-world projects</p>
            <button className="learn-more">Learn More</button>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-certificate"></i>
            </div>
            <h3>Certification</h3>
            <p>Earn industry-recognized certificates upon course completion</p>
            <button className="learn-more">Learn More</button>
          </div>
        </div>
      </section>

      <section className="why-choose-us">
        <div className="container">
          <h2>Why Choose Our Services</h2>
          <div className="benefits-grid">
            <div className="benefit">
              <h4>Flexible Learning</h4>
              <p>Learn at your own pace and schedule</p>
            </div>
            <div className="benefit">
              <h4>Expert Support</h4>
              <p>24/7 access to teaching assistants</p>
            </div>
            <div className="benefit">
              <h4>Industry Relevant</h4>
              <p>Curriculum aligned with industry needs</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services; 